import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NavBarComponent } from './core/components/navbar/navbar.component';
import { LoadingModalComponent } from '@shared/components/loading-modal/loading-modal.component';
import { CommonModule } from '@angular/common';

import { OidcSecurityService } from 'angular-auth-oidc-client';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { SignalsService } from '@shared/services/signals/signals.service';
import { ToastModule } from 'primeng/toast';
import { PrimeNGConfig } from 'primeng/api';
import { AppService } from './app.service';

import { MainComponent } from '@core/components/main/main.component';
import { TextSizeService } from '@shared/services/text-size.service';
import { ApiCacheService } from '@shared/services/cache-service/api-cache.service';
import { AdminService } from './features/admin/admin.service';
import { VersionService } from './features/about/children/version/version.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    MainComponent,
    NavBarComponent,
    LoadingModalComponent,
    ToastModule,
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AppComponent implements OnInit {
  constructor(
    private oidcService: OidcSecurityService,
    public signalService: SignalsService,
    private textSizeService: TextSizeService,
    public appService: AppService,
    private primengConfig: PrimeNGConfig,
    private cacheService: ApiCacheService,
    private adminService: AdminService,
    private versionService: VersionService
  ) {}

  ngOnInit(): void {
    this.primengConfig.ripple = true;

    //Init theme service
    this.appService.initThemeWatcher();
    
    //Check Auth
    this.checkAuth();

    // Init text service for navbar size
    this.textSizeService.initNavBarSizeWatcher();

    //Clear old cache greater than 7 days
    this.cacheService.clearOldCache();

    //Init version data
    this.initializerVersionData();
  
    if(localStorage.getItem('emulatedPilot') &&
      !this.signalService.isEumulatingEmpNumActive$()) {
      console.log('%cEmulated Pilot data found...removing pilot data', 'color: orange');
      this.adminService.resetEmulatedPilot();
    }
    
  }


  checkAuth(): void {
    console.log("%cAuthenticating User...", "color: orange");
    this.oidcService.checkAuth().subscribe((response) => {
      console.log(`%cIs authenticated: %c${response?.isAuthenticated}`, "color: lightgreen", "color: white");
      const token = response.accessToken;
      const decoded: JwtPayload & { role?: string[] } = jwtDecode(token);
      if(decoded.role) {
        const adminRole = decoded.role.some((role) => {
          return (role === 'Logbook Admins');
        });
        console.log(`%cIs Admin: %c${adminRole}`, "color: orange", "color: white");
        this.signalService._isAdminRole$.next(adminRole);
      }
      // Login not necessary, because route guards handle that.
      // Set employee number. upn is username and is empnum@[env].unionpilots.org.
      const empNumPattern = /(?<empnum>[^@]*)/; // Get everything before the @ char.
      const username = response?.userData?.upn || '';
      const empNum = username.match(empNumPattern)?.groups?.['empnum'];
      console.log(`%cActive EmpNumber: %c${empNum}`, "color: lightgreen", "color: white");
      this.signalService._authEmployeeNumber.next(empNum);
      this.signalService._empNumberObs.next(empNum);
    });
  }

  initializerVersionData(): void {
    this.versionService.initializeVersionData().subscribe({
      next: () => {
        this.versionService.getAboutBadgeValue();
      }
    });
  }
  
  // private decodeToken(token: string): any {
  //   try {
  //     const payload = token.split(".")[1];
  //     const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
  //     const jsonPayload = decodeURIComponent(
  //       window
  //         .atob(base64)
  //         .split("")
  //         .map(function (c) {
  //           return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  //         })
  //         .join("")
  //     );
  //     const decoded = JSON.parse(jsonPayload);
  //     return decoded;
  //   } catch (error) {
  //     console.error("Failed to decode JWT", error);
  //     return null;
  //   }
  // }
}
